var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v17.855h21V0H0zm10.76 12.947l-3.534-2.65 3.534-2.12v4.77zM6.74 9.154V5.159l3.388 1.962L6.74 9.154zM5.51 3.477H1.23V1.23h4.28v2.247zm-4.28 1.23h4.28v4.918H1.23V4.707zm0 6.148h4.69l4.84 3.63v2.14H1.23v-5.77zm10.76 3.938h7.78v1.832h-7.78v-1.832zm7.78-1.23h-7.78V8.199l5.345 3.094h2.435v2.27zm0-3.5h-2.105l-5.114-2.961 2.494-1.497h4.725v4.458zm0-5.688h-5.065L11.99 6.004V1.23h7.78v3.145zm-9.01 1.69L6.74 3.738V1.23h4.02v4.835z",
    transform: "translate(-20 -468) translate(20 468) translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14L7 14 7 15.23 2.625 15.23z",
    transform: "translate(-20 -468) translate(20 468) translate(0 2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanos);
export default __webpack_public_path__ + "static/media/planos.70090970.svg";
export { ForwardRef as ReactComponent };